// Hook do modal de ativacao/desativacao de CEP unico.

import { useCallback, useState } from "react";
import { toast } from "sonner";
import { bairrosApi } from "../api/bairrosApi";

export function useCepUnico({
  bairros,
  cepUnico,
  cepUnicoValue,
  setCepUnico,
  setCepUnicoValue,
  onSucesso,
}) {
  const [modalOpen, setModalOpen] = useState(false);
  const [novoCep, setNovoCep] = useState("");
  const [saving, setSaving] = useState(false);

  const onSwitchChange = useCallback(
    (checked) => {
      if (checked) {
        setNovoCep(cepUnicoValue || "");
        setModalOpen(true);
      } else {
        // Desativar — limpa estado local. NAO chama API pra "limpar CEPs"
        // (mantem comportamento legado: apenas marca como desativado)
        setCepUnico(false);
        setCepUnicoValue("");
        toast.success("CEP único desativado. Cada bairro pode ter seu próprio CEP.");
      }
    },
    [cepUnicoValue, setCepUnico, setCepUnicoValue]
  );

  const confirmar = useCallback(async () => {
    if (!novoCep.trim()) {
      toast.error("Digite o CEP");
      return;
    }
    setSaving(true);
    try {
      if (bairros.length > 0) {
        await bairrosApi.setarCepEmTodos(novoCep.trim());
      }
      setCepUnico(true);
      setCepUnicoValue(novoCep.trim());
      setModalOpen(false);
      toast.success("CEP único ativado! Todos os bairros usarão este CEP.");
      onSucesso?.();
    } catch (e) {
      toast.error("Erro ao ativar CEP único");
    } finally {
      setSaving(false);
    }
  }, [novoCep, bairros, setCepUnico, setCepUnicoValue, onSucesso]);

  return { modalOpen, setModalOpen, novoCep, setNovoCep, saving, onSwitchChange, confirmar };
}
